import { render, staticRenderFns } from "./cargoDepartmentSelect.vue?vue&type=template&id=1ce5ff08&"
import script from "./cargoDepartmentSelect.vue?vue&type=script&lang=js&"
export * from "./cargoDepartmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ce5ff08')) {
      api.createRecord('1ce5ff08', component.options)
    } else {
      api.reload('1ce5ff08', component.options)
    }
    module.hot.accept("./cargoDepartmentSelect.vue?vue&type=template&id=1ce5ff08&", function () {
      api.rerender('1ce5ff08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard/cargoDepartmentSelect.vue"
export default component.exports